<template>
  <div
    class="card organisation-card banner mb-3"
    :style="bannerStyle"
  >
    <div class="card-body">
      <div class="row row-block">
        <div class="d-flex flex-column justify-content-center col-md-6 col-block">
          <h4 class="font-weight-bold mb-0 text-white text-center">
            {{ organisation.name }}
          </h4>
          <div
            class="text-white text-small text-center"
            v-if="organisation.has_paid_license || organisation.type === 'default'"
          >
            <span v-if="organisation.address"><small>{{ organisation.address }}</small></span>
            <span v-if="organisation.zip"><small> | {{ organisation.zip }}</small></span>
            <span v-if="organisation.city"><small> | {{ organisation.city }}</small></span>
          </div>
        </div>
        <div class="p-5 col-md-6 d-flex justify-content-center align-items-center col-block">
          <img :src="organisation.logo" alt="" class="d-block img-fluid img-logo" />
        </div>
      </div>
      <hr class="d-block d-md-none" />
      <div class="row text-white">
        <div class="col-md-6">
          <a
            v-if="organisation.website && organisation.has_paid_license"
            class="btn btn-block btn-sm btn-link text-white mb-3 mb-md-0"
            :href="organisation.website"
            target="_blank"
          >
            <i class="fa fa-external-link-alt mr-2"/>
            {{ $t('phrase.view_website') }}
          </a>
        </div>
        <div class="col-md-6">
          <a
            v-if="organisation.has_paid_license || organisation.type === 'default'"
            class="btn btn-sm btn-block btn-link text-white mb-3 mb-md-0"
            href="#"
            @click.prevent="goToOrganisation(organisation.slug)"
          >
            <i class="fa fa-eye mr-2"/>
            {{ $t('word.profile_page') }}
          </a>

          <span
            v-else
            class="btn btn-sm btn-block btn-link btn-disabled text-light"
          >
            <i class="fa fa-eye mr-2"/>
            {{ $t('word.profile_page') }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { OrganisationMixin } from '@/common/utils/mixins';

export default {
  name: 'OrganisationCard',
  props: {
    organisation: {
      required: true,
      type: Object,
    },
  },
  mixins: [
    OrganisationMixin,
  ],
  methods: {
    goToOrganisation(slug) {
      this.$router.push({ name: 'organisation-detail', params: { slug } });
    },
  },
};
</script>

<style scoped>
.organisation-card {
  border-radius: 10px;
  min-height: 0;
}

.btn-disabled {
  cursor: default !important;
}

.row-block {
  min-height: 200px;
}

.img-logo {
  max-height: 100px;
  width: auto;
}

@media (max-width: 767px) {
  /* Small screens */

  .img-logo {
    max-height: 150px;
    width: auto;
  }

  .organisation-card {
    border-radius: 10px;
    min-height: 472px;
  }
}
</style>
